import { render } from "./FormCheckbox.vue?vue&type=template&id=070109ba&scoped=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=070109ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070109ba"]])

export default __exports__